import React from "react";
import { motion } from "framer-motion";
import fondo6 from "../../assets/images/fondo6.jpg";
import "../../assets/styles/Asesoria.css";

function TerminosCondiciones() {
  return (
    <main
      className="py-6 px-6 flex items-center justify-center"
      style={{
        backgroundImage: `url(${fondo6})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-white bg-opacity-95 shadow-2xl rounded-3xl p-10 max-w-5xl space-y-6 text-justify">
          <h2 className="text-3xl font-extrabold text-center text-green-900 mb-4">
            TÉRMINOS Y CONDICIONES DEL SERVICIO – NAF ESPE
          </h2>
          <p className="text-center text-sm text-gray-600">
            Última actualización: 9/07/2025
          </p>

          <p>
            El presente documento establece los Términos y Condiciones que rigen
            la participación, uso y acceso a los servicios ofrecidos por el
            proyecto NAF (Núcleo de Apoyo Contable y Fiscal) de la Universidad
            de las Fuerzas Armadas – ESPE, en colaboración con el Servicio de
            Rentas Internas (SRI) del Ecuador.
          </p>

          <h3 className="font-bold text-lg">1. Objeto del Servicio</h3>
          <p>
            El NAF tiene como finalidad brindar asistencia y orientación
            gratuita en temas contables, tributarios y fiscales a la ciudadanía,
            especialmente a sectores vulnerables, microempresarios,
            emprendedores y estudiantes, promoviendo la educación fiscal y la
            cultura tributaria.
          </p>

          <h3 className="font-bold text-lg">2. Alcance del Servicio</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Asesoría sobre inscripción y actualización del RUC.</li>
            <li>Información general sobre tipos de comprobantes y facturación.</li>
            <li>Orientación sobre régimen RIMPE y deberes formales.</li>
            <li>Capacitación y acompañamiento básico sobre declaraciones.</li>
            <li>Difusión de cultura tributaria.</li>
          </ul>
          <p className="italic text-sm text-gray-600">
            Nota: El NAF no realiza trámites directos ante el SRI ni actúa como
            representante legal o apoderado de los contribuyentes.
          </p>

          <h3 className="font-bold text-lg">3. Limitación de Responsabilidad</h3>
          <p>
            Los servicios prestados tienen carácter informativo y orientativo. En
            ningún caso el NAF, la ESPE o sus representantes serán responsables
            por decisiones administrativas, sanciones, multas o errores derivados
            del uso de la información entregada. La responsabilidad final de
            cumplir con las obligaciones tributarias recae exclusivamente en el
            contribuyente.
          </p>

          <h3 className="font-bold text-lg">4. Uso del Servicio</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Proporcionar información veraz y actualizada.</li>
            <li>Utilizar el servicio con fines lícitos y conforme a los principios del NAF.</li>
            <li>No suplantar identidad ni realizar acciones fraudulentas.</li>
          </ul>

          <h3 className="font-bold text-lg">5. Protección de Datos Personales</h3>
          <p>
            Toda información personal entregada será tratada con confidencialidad,
            únicamente para fines estadísticos, académicos y de mejora del
            servicio. No se compartirá con terceros sin autorización, salvo
            requerimientos legales o institucionales.
          </p>

          <h3 className="font-bold text-lg">6. Propiedad Intelectual</h3>
          <p>
            Todo material informativo, guías, presentaciones o contenidos
            compartidos por el NAF son de uso educativo y están protegidos por
            derechos de autor. Su reproducción total o parcial debe contar con
            autorización previa.
          </p>

          <h3 className="font-bold text-lg">7. Modificaciones</h3>
          <p>
            El NAF ESPE se reserva el derecho de modificar estos Términos y
            Condiciones en cualquier momento, publicando las actualizaciones en
            sus medios oficiales.
          </p>

          <h3 className="font-bold text-lg">8. Aceptación</h3>
          <p>
            El uso de los servicios del NAF implica la aceptación plena y sin
            reservas de estos Términos y Condiciones.
          </p>
        </div>
      </motion.div>
    </main>
  );
}

export default TerminosCondiciones;
